import React from "react";

import Box from "@mui/material/Box";

import PageHeader from "../../components/PageHeader";
import FileCard from "../../components/fileCard/FileCard";

const History = () => {
  return (
    <>
      <PageHeader sx={{ display: "flex", justifyContent: "space-between" }}>
        <h1>Autosaved History</h1>
      </PageHeader>

      {/* <Box>
        <Box sx={{ display: "flex", flexWrap: "wrap" }}>
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14].map((file) => {
            return <FileCard fileName="Sample_File" createdBy="" />;
          })}
        </Box>
      </Box> */}
    </>
  );
};

export default History;
